import { render, staticRenderFns } from "./email-confirmation-alert.vue?vue&type=template&id=25592122&"
import script from "./email-confirmation-alert.vue?vue&type=script&lang=js&"
export * from "./email-confirmation-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports